"use client";

import type { z } from "zod";

import { useRequestMutation } from "../../../../request/hooks/useRequestMutation";

export type UseRequestAdminDashboardStaffProps = {
  id: number;
};

/**
 * Mutations for a class's staff (admins) sub-resource.
 *
 * Backend contract (hallow-inc/backend #6897):
 * - POST   /communities/{id}/admin/staff            body { user_ids: number[] }
 * - DELETE /communities/{id}/admin/staff/{user_id}
 *
 * These endpoints are not yet in the generated OpenAPI schema, so they use the
 * request-based mutation pattern (mirrors useRequestAdminDashboardMembers).
 * Callers refresh the staff list via useInvalidateCommunityQueries.
 */
export const useRequestAdminDashboardStaff = ({
  id,
}: UseRequestAdminDashboardStaffProps) => ({
  mutationDelete: useRequestMutation<z.ZodString, { user_id: number }>({
    mutationFnRequestProps: ({ user_id }) => ({
      urlBackendPath: `/communities/${id}/admin/staff/${user_id}`,
      method: "DELETE",
    }),
  }),
  mutationPostMultiple: useRequestMutation<z.ZodString, { user_ids: number[] }>(
    {
      mutationFnRequestProps: (data) => ({
        urlBackendPath: `/communities/${id}/admin/staff`,
        method: "POST",
        body: JSON.stringify(data),
      }),
    },
  ),
});
